import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import { EMPTY_VALUE } from "Common/componentUtils/constants";
import { ButtonWithTooltip } from "Components/button";
import { themeVariables } from "Components/theme";
import { IWithTooltip } from "Components/withPopover";
import YesNoConfirmation from "Components/yesNoConfirmation/yesNoConfirmation";
import compact from "lodash/compact";
import filter from "lodash/filter";
import groupBy from "lodash/groupBy";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React from "react";
import { NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME, NAV_ITEM_DISABLED_CLASS_NAME, SidebarMenuItem } from "../../Common";
import { MAX_COUNT_OF_TRANSFORMS_WITHOUT_CONFIRMATION } from "../constants";
import locale from "./buildMethodSidebarItems.locale";
import classNames from "classnames";
export const buildMethodKey = (mId) => `method_${mId}`;
export const buildMethodGroupKey = (mId) => `method_${mId}`;
const confirmationPosition = {
    my: "left top",
    at: {
        x: "right",
        y: "top"
    }
};
export default (methodsForShowing, availableMethodsMap, selectedNodesSource, showHints, readOnlyMode, popoverRefs, onAddClick, onRunClick, runOnItemClick) => isEmpty(methodsForShowing)
    ? []
    : map(groupBy(methodsForShowing, m => m.GroupName || EMPTY_VALUE), (items, groupName) => {
        const groupItem = new SidebarMenuItem(groupName, groupName, undefined, undefined, undefined, map(items, m => {
            const e = new SidebarMenuItem(buildMethodKey(m.Id), m.Name, undefined, undefined, m);
            if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
                e.className = NAV_ITEM_DISABLED_CLASS_NAME;
            }
            else if (onAddClick || onRunClick || selectedNodesSource) {
                const nodesSourcesForMethod = filter(selectedNodesSource, n => includes(availableMethodsMap[n.DocumentObjectId], m.Id));
                let runMethodElement;
                let needConfirm = false;
                if (onRunClick) {
                    const runCallback = () => {
                        onRunClick && onRunClick(m, nodesSourcesForMethod);
                    };
                    needConfirm =
                        nodesSourcesForMethod.length > MAX_COUNT_OF_TRANSFORMS_WITHOUT_CONFIRMATION;
                    const runMethodButton = (React.createElement(ButtonWithTooltip, { key: "play", className: "p-0 no-default-colors no-border flex-box-centered-content", wrapperClassName: "flex-box-centered-content", popoverContent: showHints ? locale.RUN_METHOD : "", onClick: !needConfirm ? runCallback : undefined },
                        React.createElement("i", { className: "icon-play text-light-on-surface-variant font-h4 flex-box-centered-content" })));
                    if (needConfirm) {
                        popoverRefs.current[m.Id] = React.createRef();
                        runMethodElement = (React.createElement(YesNoConfirmation, { popoverRef: popoverRefs.current[m.Id], key: "play", showEvent: "dxclick", onConfirm: runCallback, title: locale.getConfirmRunText(nodesSourcesForMethod.length), zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 2, position: confirmationPosition }, runMethodButton));
                    }
                    else {
                        runMethodElement = runMethodButton;
                    }
                    if (runOnItemClick) {
                        e.onItemClick = () => {
                            var _a, _b;
                            if (needConfirm) {
                                (_b = (_a = popoverRefs.current[m.Id]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.instance.show();
                            }
                            else {
                                runCallback();
                            }
                        };
                    }
                }
                e.actionElements = compact([
                    onAddClick && (React.createElement(IWithTooltip, { key: "add", className: classNames("icon-add font-h3 flex-box-centered-content text-light-on-surface-variant", NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME), popoverContent: showHints ? locale.ADD_METHOD : "", onClick: () => {
                            onAddClick && onAddClick(m, nodesSourcesForMethod);
                        } })),
                    runMethodElement
                ]);
            }
            return e;
        }));
        if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
            groupItem.className = NAV_ITEM_DISABLED_CLASS_NAME;
        }
        return groupItem;
    });
